import { LargeScreen, SmallScreen } from 'pared/components/responsive'

import WebLargeMain from './WebLargeMain'
import WebSmallMain from './WebSmallMain'

interface IProps {
  xAxisData: string[]
  yAxisLocationData: number[]
  yAxisSystemwideData: number[]
  locationName: string
}

function Main({
  xAxisData,
  yAxisLocationData,
  yAxisSystemwideData,
  locationName,
}: IProps) {
  return (
    <>
      <LargeScreen>
        <WebLargeMain
          xAxisData={xAxisData}
          yAxisLocationData={yAxisLocationData}
          yAxisSystemwideData={yAxisSystemwideData}
          locationName={locationName}
        />
      </LargeScreen>
      <SmallScreen>
        <WebSmallMain
          xAxisData={xAxisData}
          yAxisLocationData={yAxisLocationData}
          yAxisSystemwideData={yAxisSystemwideData}
          locationName={locationName}
        />
      </SmallScreen>
    </>
  )
}

export default Main
